<template>
    <div>
        <div class='about-bg'>
            <el-image :src="about_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class="about-item">
<!--              <el-image v-show="$i18n.locale==='zh'" :src="about_content" class="about-item-zh"></el-image>-->
<!--              <el-image v-show="$i18n.locale==='en'" :src="about_content_en" class="about-item-en"></el-image>-->
              <div class="about-item-en">
                <p>Grande Games is a top tier Social Casino games company. With massive mobile game hits such as Cash frenzy™, Lotsa Slots™ and Jackpot World, Grande Games is by far the fastest growing company in the entire Social Casino category! </p>
                <p>With hundreds of top-quality slots in every app and innovative meta-game systems, our apps are captivating millions of slot lovers from all over the world every single day. Our loyal players have propelled our apps straight to the top of the revenue charts and our growth speed just keeps getting faster and faster!</p>
                <p>Our next generation of apps, Vegas Friends™ and Jackpot Crush, built on the popular Unity platform, offer even more stunning graphics and gameplay… Our apps are available on Android, iOS and Amazon platforms.</p>
                <p>Our mission is to deliver lucky moments and pure fun to players all over the world!</p>
              </div>
              <div class="mobile-about">
                <p>Grande Games is a top tier Social Casino games company. With massive mobile game hits such as Cash frenzy™, Lotsa Slots™ and Jackpot World, Grande Games is by far the fastest growing company in the entire Social Casino category! </p>
                <p>With hundreds of top-quality slots in every app and innovative meta-game systems, our apps are captivating millions of slot lovers from all over the world every single day. Our loyal players have propelled our apps straight to the top of the revenue charts and our growth speed just keeps getting faster and faster!</p>
                <p>Our next generation of apps, Vegas Friends™ and Jackpot Crush, built on the popular Unity platform, offer even more stunning graphics and gameplay… Our apps are available on Android, iOS and Amazon platforms.</p>
                <p>Our mission is to deliver lucky moments and pure fun to players all over the world!</p>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return {
      about_header: `${require('../assets/img_grande/new_home_1.jpg')}`,
      about_content: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_1.png',
      about_content_en: `${require('../assets/images_bole/grande_about_en.jpg')}`
      // about_content_en: `${require('../assets/images/about_1_en.png')}`,
    }
  },
  computed: {
    //是否使用移动端视频
    // about_content_en() {
    //   return document.documentElement.clientWidth > 992 ? 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_1_en.png' : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_en_mobile.png';
    // },
  },
}
</script>

<style lang="less">
.about-item {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
}
.about-item-en {
  width: 65%;
  color: #fff;
  background: #07083290;
  text-align: justify;
  padding: 20px 0;
  margin: 0 auto;
  line-height: 27px;
  p {
    padding: 10px 40px 0px;
    font-size: 16px;
    margin: 0px;
    font-weight: 800;
    color: #d4cff5;
  }
}
.mobile-about {
  display: none;
  color: #fff;
  background: #07083290;
  margin: 0 auto;
  width: 78%;
  text-align: justify;
  padding: 10px 0;
  p {
    padding: 0px 20px;
    font-size: 14px;
  }
}
@media screen and (max-width: 926px) {
  .about-item {
    margin-top: 20px;
    width: 110%;
    right: 5%;
    position: relative;
  }
  .about-item-en {
    width: 70%;
    display: none;
  }
  .mobile-about {
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/About.vue